import { useAuthenticationStore } from '@/stores/authenticationStore';
import type { Middleware } from './generator';

export const xsrfTokenMiddleware: Middleware = {
  async pre(context) {
    context.init.headers = {
      ...context.init.headers,
      'X-XSRF-TOKEN': useAuthenticationStore().xsrfToken,
    };
    return context;
  },
};
